<script>

    import { InvoiceClientStore, InvoiceStore, UserStore } from '../stores'
    
    import Invoices from '../invoices/invoices.svelte'
    import InvoiceRead from '../invoices/invoice.svelte'
    import InvoiceClient from '../invoices/invoice.client.svelte'
    import InvoiceClientCreate from '../invoices/invoice.client.create.svelte'

    import Button from '../$components/button.svelte'
    import Modal from '../$components/modal.svelte'

</script>

<Modal id="InvoiceRead" title="Factura" >
    <InvoiceRead on:deleted={InvoiceStore.modalClose} />
</Modal>

<Modal id="InvoiceClientCreate" title="Datos de facuración" >
    <InvoiceClientCreate on:created={InvoiceClientStore.modalClose} on:canceled={InvoiceClientStore.modalClose} />
</Modal>

{#if !$UserStore.facturamaId}
    <div class="space top bottom">
        <div class="items center space bottom subtitle">Aún no ingresas tus datos de facturación, da click en el botón para guardarlos</div>
        <div class="items center">
            <Button on:click={() => InvoiceClientStore.modalCreate()} icon="plus" text="Agregar" color="primary" />
        </div>
    </div>
{:else}
    <div class='columns'>
        <div class='column'>
            <Invoices />
        </div>
        <div class="is-divider-vertical"></div>
        <div class="column is-4">
            <InvoiceClient />
        </div>
    </div>
{/if}